<section class="welcome_area clearfix" id="home">
    <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-6">
                    <div class="welcome-heading">
                        <h1>INGHERRERA</h1>
                        <br>
                        <h2>DESARROLLANDO NEGOCIOS</h2>
                        <p style="margin-top: 40px;">
                            "Nuestra filosofía consiste en obtener resultados de forma ágil y eficiente a nuestros clientes."
                        </p>
                    </div>
                </div>
                <div class="col-6 text-center">
                    <!-- <img src="assets/img/logo2.png"> -->
                </div>
            </div>
    </div>
    <svg id="svg-separator" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
    <polygon fill="white" points="0,100 100,0 100,100"/>
  </svg>
</section>